<mat-tab-group #myTabGroup
               [class.hide-criteria-update-history]="hideCriteriaUpdateHistory"
               [selectedIndex]="isInforTab"
               (selectedIndexChange)="isInforTab = $event">
  <mat-tab [label]="'add_document_moha.labor_contract_report_information' | translate">
  </mat-tab>
  <mat-tab *ngIf="!hideCriteriaUpdateHistory" [label]="'add_document_moha.criteria_update_history' | translate">
    <mat-card-content class="mb-3 mat-card-content-contract-sm" style="overflow-y: auto; width: 100%; overflow-x: hidden;">
      <div class="table-container" style=" display: block;max-height: 590px">
        <table mat-table [dataSource]="listDataVersionHistory" class="mat-table-col-extra-sm mat-table table table-history">
          <ng-container *ngFor="let col of displayedHistoryColumns" [matColumnDef]="col">
            <th mat-header-cell *matHeaderCellDef 
            class="col-cell" 
            [matTooltip]="getField(col)?.name"
            matTooltipPosition="above">
              {{ getField(col)?.name }}
            </th>
            <td mat-cell *matCellDef="let element" class="col-cell"
            [ngClass]="{
              'text-left': getField(col)?.inputType !== 'DATETIME',
              'text-center': getField(col)?.inputType === 'DATETIME'
            }"
            [matTooltip]="getField(col)?.inputType === 'DATETIME' 
            ? (element[col] ? getFormatDate(element[col]) : '')
            : element[col]"
            matTooltipPosition="above"
            >
              <ng-container [ngSwitch]="getField(col)?.inputType">
        
                <!-- DATETIME -->
                <span *ngSwitchCase="'DATETIME'"
                >
                  {{ element[col] ? getFormatDate(element[col]) : '' }}
                </span>
                <span *ngSwitchCase="'DROPDOWN'"
                style="white-space: nowrap;"
                >
                  {{getDataDropdown(getField(col), element[col])}}
                </span>
                <!-- DEFAULT -->
                <span *ngSwitchDefault
                style="white-space: nowrap;"
                >
                  {{ element[col] }}
                </span>
              </ng-container>
            </td>
          </ng-container>
          <ng-container *ngFor="let group of historyGroupRowColumns; let i = index" [matColumnDef]="group">
            <th mat-header-cell *matHeaderCellDef class="group-cell text-center"
              [attr.colspan]="historyGroupColumns[i].span"
              [style.width.px]="historyGroupColumns[i].span * historyColumnWidth">
              {{ historyGroupColumns[i].name }}
            </th>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="historyGroupRowColumns; sticky: true"></tr>
          <tr mat-header-row *matHeaderRowDef="displayedHistoryColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedHistoryColumns;"></tr>
        </table>
      </div>
    </mat-card-content>
      <div mat-dialog-actions class="justify-content-center" style="margin-top: 24px;">
        <button mat-stroked-button color="primary" class="mr-3" [disabled]="isSaving" (click)="onNoClick()">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.close' | translate}}
        </button>
      </div>
  </mat-tab>
</mat-tab-group>
<mat-card class="form-view-step-3" [class.criteria-edit-mode]="canEdit" [ngClass]="isInforTab === 0 ? '' : 'd-none'">
  <mat-divider></mat-divider>
  <mat-card-content class="mb-3 mat-card-content-contract-sm" style="overflow-y: auto; width: 100%; overflow-x: hidden;">
    <div class="row" style="overflow-y: auto">
      <div class="col-12" style="padding-right: 0;">
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel expanded="true" class="mt-3 mat-elevation-z0">
            <div class="row mt-2">
              <div class="col-4" style="padding-left: 28px;">
                <mat-form-field class="w-100 dynamic-view">
                  <input style="font-weight: 500; color: black;" matInput type="text" [value]="customerMohaName" [placeholder]="'add_document_moha.employee' | translate" disabled/>
                </mat-form-field>
              </div>
            </div>
            <!-- Tiêu chi mặc định  -->
            <mat-expansion-panel #mainCriteriaPanel expanded="true" class="mt-3 mat-elevation-z0" [class.criteria-panel]="canEdit">
              <mat-expansion-panel-header>
                <mat-panel-description class="mat-panel-title">
                  {{ "add_document_moha.employment_contract_data" | translate }} &nbsp;
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div #criteriaContainer [class.criteria-table-wrapper]="canEdit">
                <mat-table [dataSource]="listDataTable" [trackBy]="trackByCode" class="criteria-table">
                  <ng-container matColumnDef="groupHeader">
                    <mat-cell *matCellDef="let element" class="group-header-cell">
                      <button mat-icon-button type="button" class="toggle-button" (click)="toggleGroup(element)">
                        <ng-container *ngIf="!element.expanded"> 
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 8H10M8 6V10M2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333Z" stroke="#6F767E" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                      </ng-container>
                      <ng-container *ngIf="element.expanded"> 
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.33333 8H10.6667M5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V5.2C14 4.0799 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                      </ng-container>
                      </button>
                      <strong>{{ element.name }}</strong>
                    </mat-cell>
                  </ng-container>
                  <!-- STT -->
                  <ng-container matColumnDef="stt">
                    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                      {{ "headertable.stt" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom">
                      <button *ngIf="element.rowType === 'subheader'" mat-icon-button type="button"
                        class="toggle-button" (click)="toggleGroup(element)">
                        <mat-icon>{{ element.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                      </button>
                      <span *ngIf="!element.level || element.level <= 1">{{ element.displayOrder }}</span>
                    </mat-cell>
                  </ng-container>
                  <!-- Tên tiêu chí -->
                  <ng-container matColumnDef="nameCriteria">
                    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                      {{ "add_document_moha.criteria_name" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" [matTooltip]="element.name"
                      [class.subheader-name]="element.rowType === 'subheader'"
                      class="mat-cell-non-boder-right-bottom cell">
                      <span class="fix-width fw-100 nameDoc">
                        <span *ngIf="element.level > 1" class="child-display-order">{{ element.displayOrder }}</span>
                        {{ element.name }}
                        <span *ngIf="isEditMode && element.rowType === 'criterion' && element.isRequired" style="color: red">&nbsp;*</span>
                      </span>
                    </mat-cell>
                  </ng-container>
                  <!-- Trường thông tin của mẫu -->
                  <ng-container matColumnDef="infoTemplate">
                    <mat-header-cell *matHeaderCellDef class="text-center mat-header-cell-center mat-cell-non-boder-right-bottom">
                      {{ "handsontable.title.value" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom">
                      <span *ngIf="element.rowType === 'criterion' && !canEdit" class="view-value"
                        [matTooltip]="getDisplayValue(element)">
                        {{ getDisplayValue(element) }}
                      </span>
                      <ng-container *ngIf="element.rowType === 'criterion' && canEdit"
                        [ngTemplateOutlet]="criterionControl" [ngTemplateOutletContext]="{ $implicit: element }">
                      </ng-container>
                    </mat-cell>
                  </ng-container>
  
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: headerColumns; when: isHeaderRow"
                    [class.row-hidden]="!isRowVisible(row)" class="group-header-row">
                  </mat-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns; when: isCriterionRow"
                    [class.subheader-row]="row.rowType === 'subheader'"
                    [class.row-hidden]="!isRowVisible(row)" class="criterion-row">
                  </mat-row>
                </mat-table>
              </div>
            </mat-expansion-panel>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </mat-card-content>
  <div mat-dialog-actions class="justify-content-center">
    <!-- <button *ngIf="canEdit" mat-stroked-button color="primary" class="mr-3" [disabled]="isSaving" (click)="onNoClick()">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button> -->
    <button mat-stroked-button color="primary" class="mr-3" [disabled]="isSaving" (click)="onNoClick()">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.close' | translate}}
    </button>
    <button *ngIf="canEdit && !isEditMode && isPermissionProperties" mat-raised-button color="primary" [disabled]="isSaving" (click)="startEditing()">
      <mat-icon class="mr-0">edit</mat-icon>
      {{'button.update' | translate}} 
    </button>
    <button *ngIf="isEditMode" mat-raised-button color="primary" [disabled]="isSaving" (click)="save()">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.save' | translate}}
    </button>
  </div>
</mat-card>

<ng-template #criterionControl let-element>
  <div class="criterion-control" [ngSwitch]="element.inputType"
    [attr.data-validation-code]="element.code"
    [class.control-invalid]="element.controlField?.touched && element.controlField?.invalid">
    <nz-input-group *ngSwitchDefault class="report-input-group" [nzSuffix]="clearInput">
      <input nz-input type="text" autocomplete="off" [maxlength]="element.maxLength || 255"
        [readOnly]="isSaving" [formControl]="element.controlField" (focusout)="trimText(element)"
        [placeholder]="'add_document_moha.enter_information_field' | translate" />
    </nz-input-group>
    <ng-template #clearInput>
      <i *ngIf="element.controlField?.value && !isSaving && !element.controlField?.disabled" nz-icon nzType="close-circle" nzTheme="fill"
        class="input-clear-icon" (click)="clearText(element)"></i>
    </ng-template>
    <nz-select *ngSwitchCase="'DROPDOWN'" class="merge-field-select" nzShowSearch nzAllowClear [nzDisabled]="isSaving || element.controlField?.disabled"
      [nzPlaceHolder]="'add_document_moha.select_information_field' | translate" [formControl]="element.controlField">
      <nz-option *ngFor="let option of optionsMap.get(element.code)" [nzValue]="option.value" [nzLabel]="option.name"></nz-option>
    </nz-select>
    <nz-date-picker *ngSwitchCase="'DATETIME'" class="report-control" nzAllowClear nzFormat="dd/MM/yyyy" [nzDisabled]="isSaving || element.controlField?.disabled"
      [nzDisabledDate]="getDisabledDateForField(element)"
      (nzOnOpenChange)="onDatePickerOpenChange($event, element)"
      [nzPlaceHolder]="'add_document_moha.select_information_field' | translate" [formControl]="element.controlField">
    </nz-date-picker>
    <ng-container *ngIf="element.controlField?.touched">
      <div *ngIf="element.controlField?.errors?.invalidDateFormat" class="control-error">
        Ngày không đúng định dạng dd/MM/yyyy
      </div>
      <div *ngIf="element.controlField?.errors?.required" class="control-error">
        {{ element.requiredMessage || ('add_document_moha.required_field' | translate : ({field: element.name})) }}
      </div>
      <div *ngIf="element.controlField?.errors?.pattern" class="control-error">
        {{ element.regexMessage || ('add_document_moha.wrong_format' | translate : ({field: element.name})) }}
      </div>
      <div *ngIf="element.controlField?.errors?.maxlength" class="control-error">
        {{ element.name }}: tối đa {{ element.maxLength || 255 }} ký tự
      </div>
      <div *ngIf="element.controlField?.errors?.contractStartNotAfterBirthDate" class="control-error">
        Thời điểm bắt đầu HĐLĐ phải lớn hơn ngày sinh của NLĐ
      </div>
    </ng-container>
    <div *ngIf="element.controlField?.errors?.hazardousDateOrder && isDateRangeTouched('nndh_ket_thuc')" class="control-error">
      Ngày tham gia làm nghề phải nhỏ hơn ngày kết thúc làm nghề
    </div>
    <div *ngIf="element.controlField?.errors?.contractDateOrder && isDateRangeTouched('ngay_ket_thuc_hdld')" class="control-error">
      Thời điểm kết thúc HĐLĐ phải lớn hơn hoặc bằng Thời điểm thực hiện HĐLĐ
    </div>
  </div>
</ng-template>
